import React from 'react';
import _ from 'lodash';
import cn from 'classnames';
import Paragraph from './Paragraph';

const LinkBlocks = ({ entity }) => {

  const children = entity.fieldItems.map((item) => (
    <Paragraph key={item.entity.entityId} entity={item.entity} overrideProps={{"content_wysiwyg": { "withWrapper": true }}} />
  ))
  const className = entity.fieldItems.length % 2 ? 'odd' : 'even';

  return (
   <div className={cn("link-blocks", className)}>{children}</div>
  );
}
export default LinkBlocks;
